<div class="db-ecommerce-1wf">
  <div class="db-ecommerce-1wf__explore" [ngClass]="{'scrolled': !!scrolled}">
 <!--   <div class="db-black-offer-banner-ecom-mobile" *ngIf="!!isMobile">
      <p>Black Friday Special:<br/> <span>+30% off first payment</span></p>
    </div>-->
    <h1 [ngClass]="{'mt20': !isMobile}">Explore 10Web<br/> Ecommerce for Free</h1>
    <p class="mt10">Personalize your online store,<br/> add your products, and start selling.</p>

<!--    <div class="db-black-offer-banner-ecom mt20" *ngIf="!isMobile">
      <p>Black Friday Special: <span>+30% off first payment</span></p>
    </div>-->

    <a class="{{isMobile ? 'ds-btn-purple-blue' : 'ds-btn-black'}} rectangle ds-btn-l mt40"
       [ngClass]="{'mt50': !isMobile, 'mt20': !!isMobile}"
       (click)="onStepChange.emit('plans')">
      <span>{{'Try It Free for 7 Days' | lowerCaseSpecificWords}}</span>
    </a>
  </div>
  <div class="db-ecommerce-1wf__information" [ngClass]="{'desktop': !isMobile}">
    <div>
      <ng-container   *ngFor="let item of features; let i = index">
        <h2 *ngIf="!!item?.header" class="mb1"
            [ngClass]="{'mt40': i !== 0 && !isMobile,
                        'mt30': i !== 0 && !!isMobile }">{{item?.title}}</h2>
        <p *ngIf="!item?.header" [ngClass]="{'mt14': !isMobile, 'mt11': !!isMobile}">
          <i class="db-icon db-icon-ds-checkmark"></i>{{item?.title}}
        </p>
      </ng-container>
    </div>
  </div>
</div>
